import { AfterViewInit, ChangeDetectionStrategy, Component, TemplateRef, ViewChild } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { DialogService } from '@next/core-lib/dialog';
import { LocaleService, AgrI18nSharedModule } from '@next/core-lib/i18n';

import { ReturnDateHelpDialogComponent } from '../return-date-help-dialog/return-date-help-dialog.component';

@Component({
  templateUrl: './label-delivery-date.component.html',
  styleUrls: ['./label-delivery-date.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButton, MatIcon, AgrI18nSharedModule],
})
export class LabelDeliveryDateComponent implements AfterViewInit {
  @ViewChild('template') template: TemplateRef<unknown>;
  @ViewChild('mobileTemplate') mobileTemplate: TemplateRef<unknown>;
  initCallback: () => void;

  constructor(
    private readonly dialogService: DialogService,
    private readonly locale: LocaleService,
  ) {}

  public openReturnDateHelpModal() {
    this.dialogService.responsiveDialog(ReturnDateHelpDialogComponent, {
      title: this.locale.translate('cart.return-date-help-modal.title'),
      cancelButton: false,
      disableClose: true,
      confirmButtonText: this.locale.translate('cart.help-modal.close'),
      confirmButton: true,
    });
  }

  ngAfterViewInit() {
    this.initCallback();
  }
}
